import { render, staticRenderFns } from "./newNews.vue?vue&type=template&id=d047dc82&scoped=true&lang=html&"
import script from "./newNews.vue?vue&type=script&lang=js&"
export * from "./newNews.vue?vue&type=script&lang=js&"
import style0 from "./newNews.vue?vue&type=style&index=0&id=d047dc82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d047dc82",
  null
  
)

export default component.exports